import React from 'react';
import { Home as HomeIcon, MessageCircle, Search } from 'lucide-react';
import { Button } from '../components/ui/button';
import { generateWhatsAppLink } from '../utils/whatsappTemplates';

const NotFound = () => {
  const whatsappLink = generateWhatsAppLink('support', { issue: 'I need help finding a page' });

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto text-center">
          <div className="mb-8">
            <div className="text-9xl font-bold text-[#039fff] mb-4">404</div>
            <div className="text-6xl mb-4">🚚💨</div>
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold text-[#001A47] mb-4">
            This page took a wrong turn
          </h1>
          <p className="text-xl text-gray-600 mb-8">
            We couldn't find the page you're looking for. But don't worry, we can still help you!
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <a href="/">
              <Button size="lg" className="bg-[#001A47] hover:bg-[#002B6B] text-white px-8 w-full sm:w-auto">
                <HomeIcon className="mr-2 h-5 w-5" />
                Back to Home
              </Button>
            </a>
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
              <Button size="lg" variant="outline" className="border-[#fb6402] text-[#fb6402] hover:bg-[#fb6402] hover:text-white px-8 w-full sm:w-auto">
                <MessageCircle className="mr-2 h-5 w-5" />
                Need Help? WhatsApp Us
              </Button>
            </a>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8">
            <h3 className="text-xl font-bold text-[#001A47] mb-4">Popular Pages</h3>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              <a href="/deliveries" className="text-[#039fff] hover:underline">Deliveries</a>
              <a href="/mini-moves" className="text-[#039fff] hover:underline">Mini-Moves</a>
              <a href="/business" className="text-[#039fff] hover:underline">Business</a>
              <a href="/areas" className="text-[#039fff] hover:underline">Areas We Serve</a>
              <a href="/track" className="text-[#039fff] hover:underline">Track Order</a>
              <a href="/contact" className="text-[#039fff] hover:underline">Contact Us</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
